import { Outlook, Dropbox, Figma, Github, GoogleDrive, Jira, Gmail, Monday, Notion, Slack, Trello } from 'assets';
import { dateRangesEnum } from './Enum';

export const integrationList = [
    { title: 'Outook', icon: Outlook, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Dropbox', icon: Dropbox, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Figma', icon: Figma, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Github', icon: Github, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'GoogleDrive', icon: GoogleDrive, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Jira', icon: Jira, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Gmail', icon: Gmail, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Monday', icon: Monday, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Notion', icon: Notion, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Slack', icon: Slack, desc: 'Supercharge your workflow and connect the tool you use every day.' },
    { title: 'Trello', icon: Trello, desc: 'Supercharge your workflow and connect the tool you use every day.' }
];

export const optionsDateRange = [
    ...Object.entries(dateRangesEnum).map(([key, value]) => {
        return {
            title: value
        };
    })
];
